module.exports = __webpack_public_path__ + "img/infoicon.027323bc.svg";